import { render, staticRenderFns } from "./ActiveFilterItem.vue?vue&type=template&id=1958320a&scoped=true"
import script from "./ActiveFilterItem.vue?vue&type=script&lang=js"
export * from "./ActiveFilterItem.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilterItem.vue?vue&type=style&index=0&id=1958320a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958320a",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Factive-filter%2FActiveFilterItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports